<template>
  <div class="content mobile-lesson">
    <div class="course-lesson">
      <div>
        <form id="lesson_test">
          <div id="msg_top" v-if="show_passed_msg" :class="{'show-congratulations': show_passed_msg}" class="congratulations-container">
          <CongratulationsSectionMob
            :certificate_availbility="certificate_availability"
            :hot_user="hot_user"
            :its_super_admin="its_super_admin"
            :next_course_message="next_course_message"
            :pass_message="pass_message"
            :practice_test="open_test.practice_test">
          </CongratulationsSectionMob>
        </div>
          <card :class="{'hide-body': show_passed_msg}" class="no-border-card custmHeightCard p-0" style="overflow: visible">
            <div class="card-qheader mb-4">
              <div class="row align-items-center">
                <div class="col-8 d-flex">
                  <img src="/img/svg-icons/bk_btn.svg" alt="Image placeholder" class="m-0" @click="onBackClick" />
                  <h2 class="mb-0 attemp-course pl-3 card-header-hd">
                    <span class="test-courst-name d-block text-white">{{
                      course_name
                    }}</span>

                    <span class="test-q-name d-block text-white"><span class="test-q-name text-white">{{
                      show_lesson ? "" + open_lesson.name : ""
                    }}</span>{{
                          show_test && !open_test.practice_test
                            ? " Test "
                            : show_test && open_test.practice_test
                              ? "Practice Test"
                              : ""
                        }}{{
                        show_lesson && showQuizFlag
                          ? " &nbsp; &gt; &nbsp; Quiz"
                          : ""
                      }}</span>
                  </h2>
                </div>

                <div class="col-4 d-flex justify-content-end" v-if="!its_super_admin">
                  <span class="counter">
                    <img src="/img/svg-icons/timer-icon.svg" alt="" class="timer-img" />
                    <label class="hours m-0" :id="'hours_' + crrTimestamp">00</label>
                    <label class="m-0" id="colon">:</label>
                    <label class="hours m-0" :id="'minutes_' + crrTimestamp">00</label>
                    <label class="m-0" id="colon">:</label>
                    <label class="hours m-0" :id="'seconds_' + crrTimestamp">00</label>
                  </span>
                  <input type="hidden" id="hiddenInput" />
                </div>
              </div>
              <div class="progress-area d-flex align-items-center" v-if="!showDescriptionStep && getTotalQuestions > 0">
                <!-- Dynamic progress text based on current question and total questions -->
                <span class="text-white txt-size">
                  {{ currentQuestionIndex + 1 }}/{{ getTotalQuestions }}
                </span>
                <el-progress class="w-100" :show-text="false" :percentage="progressPercentage"></el-progress>
              </div>
            </div>
            <!-- Pretest Open --->
            <div class="cart-question-area">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="Course" name="first">
                  <div class="row align-items-center" v-if="pretestFlag">
                    <div class="col-md-6">
                      <span class="form-inline">
                        <h2 class="mb-0">Pre Test</h2>
                        <br />
                      </span>
                    </div>
                    <div class="btn-sticky-area">
                    <div class="remain-attempts">
                      <base-button class="w-100 lesson-btn " name="Save Pretest" @click.prevent="savePretest()" type="primary">Next <i class="fa fa-arrow-right"></i></base-button>
                  </div>
                  </div>
                  </div>
                  <div class="d-inline-block" v-else-if="(show_test || show_lesson) && !show_scorm">
                    <div class="remain-attempts mb-2">
                      <p class="px-3 attmp-time" v-if="
                        (show_test && !open_test.practice_test) ||
                        showQuizFlag
                      ">
                        Remaining attempts:
                        {{
                          show_test
                            ? open_test.remaining_attempts
                            : open_lesson.remaining_attempts
                        }}
                      </p>
                    </div>
                  </div>
                  <div v-if="show_test && !this.scormFlag">
                    <!-- Show test description first -->
                    <div v-if="showDescriptionStep">
                      <div class="passing-gread">
                        {{
                          show_test && !open_test.practice_test
                            ? "Passing Grade " + this.passing_percent + "%"
                            : ""
                        }}
                      </div>
                      <div class="text-justify course-disc" v-html="open_test.quiz_instruction"></div>
                    </div>
                    <div v-if="showDescriptionStep">
                      <div class="btn-sticky-area">
                        <div class="col-md-12 text-right mt-4">
                          <base-button  name="Start Test" class="w-100 lesson-btn" @click.prevent="startQuestions()"
                            type="primary">Start Test<i class="fa fa-arrow-right"></i></base-button>
                        </div>
                      </div>
                    </div>

                    <!-- Show test questions after description -->
                    <div v-else>
                      <div class="mt-2" v-if="
                        open_test.questions && open_test.questions.length > 0
                      ">
                        <div class="row">
                          <div class="col-md-12 form-inline">
                            <h6 class="questionname">
                              <b>
                                <i :id="'correct_' +
                                  open_test.questions[currentQuestionIndex].id
                                  " class="fa fa-check" style="display: none; color: green"></i>
                                <i :id="'incorrect_' +
                                  open_test.questions[currentQuestionIndex].id
                                  " class="fa fa-times" style="display: none; color: red"></i>
                                {{
                                  open_test.questions[currentQuestionIndex]
                                    .sr_no
                                }}.
                                {{
                                  open_test.questions[currentQuestionIndex]
                                    .question_text
                                }}
                              </b>
                            </h6>
                          </div>
                        </div>
                        <div class="row" :key="option.id" v-for="(option, o_index) in open_test.questions[
                          currentQuestionIndex
                        ].options">
                          <div class="col-md-12 qtn-checkbox">
                            <div class="d-flex left-margin justify-content-between">
                              <label :for="'test' + option.id" :id="open_test.questions[currentQuestionIndex].id +
                                '_' +
                                option.id
                                " class="qtn-checkbox" :class="{
                                    'lable-style':
                                      open_test.questions[currentQuestionIndex]
                                        .selected === option.id,
                                  }">
                                <span>{{ option.option_text }}</span>

                                <input v-if="
                                  open_test.questions[currentQuestionIndex]
                                    .selected
                                " :checked="true" :name="'test' +
                                      open_test.questions[currentQuestionIndex].id
                                      " :id="'test' + option.id" :value="option.id" type="radio" v-model="open_test.questions[currentQuestionIndex]
                                        .selected
                                      " v-on:input="
                                      optionTestChecked(
                                        currentQuestionIndex,
                                        o_index,
                                        option.id
                                      )
                                      " />
                                <input v-else :checked="false" :name="'test' +
                                  open_test.questions[currentQuestionIndex].id
                                  " :id="'test' + option.id" :value="option.id" type="radio" v-model="open_test.questions[currentQuestionIndex]
                                        .selected
                                      " v-on:input="
                                      optionTestChecked(
                                        currentQuestionIndex,
                                        o_index,
                                        option.id
                                      )
                                      " />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="btn-sticky-area">
                          <div class="row">
                            <div class="col-md-12 d-flex">
                              <base-button name="Previous" @click.prevent="prevQuestion()" type="primary"
                                class="w-100 lesson-btn" v-if="currentQuestionIndex > 0"><i
                                  class="fa fa-arrow-left"></i>
                                Previous</base-button>
                              <base-button name="Next" class="w-100 lesson-btn" @click.prevent="nextQuestion()"
                                type="primary" v-if="
                                  currentQuestionIndex <
                                  open_test.questions.length - 1
                                ">Next <i class="fa fa-arrow-right"></i></base-button>
                              <base-button name="Submit Test" class="w-100 lesson-btn" @click.prevent="submitTest()"
                                type="primary" v-if="
                                  currentQuestionIndex ===
                                  open_test.questions.length - 1 &&
                                  !open_test.practice_test
                                ">Submit <i class="fa fa-check"></i></base-button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="text-left mt-3" v-if="open_test.practice_test">
                        <span v-if="!finishedPracticeTest">
                          <base-button @click.prevent="draftPracticeTest()" type="primary" v-if="
                            !practiceSubmitDisable &&
                            currentQuestionIndex ===
                            open_test.questions.length - 1
                          ">
                            Save Draft
                          </base-button>
                          <base-button name="Submit Pretest" @click.prevent="submitPracticeTest()" type="primary" v-if="
                            !practiceSubmitDisable &&
                            currentQuestionIndex ===
                            open_test.questions.length - 1
                          ">
                            Submit
                          </base-button>
                          <base-button name="Submit Lesson" @click.prevent="refershPracticeTest()" type="primary"
                            v-else-if="
                              practiceSubmitDisable &&
                              currentQuestionIndex ===
                              open_test.questions.length - 1
                            ">
                            Next <i class="fa fa-angle-double-right"></i>
                          </base-button>

                          <span class="styleResult" v-if="practiceSubmitDisable">Result:
                            <b id="styleResultId">{{
                              Math.round(
                                (correctQuestions /
                                  open_test.questions.length) *
                                100
                              )
                            }}%
                            </b>
                          </span>
                        </span>
                        <span v-else>
                          <base-button name="Test Finshed" @click.prevent="
                            showPassedMsg();
                          practiceTestFinish();
                          " type="primary">
                            Finish
                          </base-button>
                        </span>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>


                  <div class="" v-if="show_passed_msg">
                    <div class="row">
                      <div class="col-md-4">
                        <h1 class="mb-0 text-center mb-3">{{ course_name }}</h1>
                      </div>
                      <div class="col-md-8 text-right" v-if="!its_super_admin">
                        <span class="counter" v-show="false">
                          <label class="hours" :id="'hours_' + crrTimestamp">00</label>
                          <label id="colon">:</label>
                          <label class="hours" :id="'minutes_' + crrTimestamp">00</label>
                          <label id="colon">:</label>
                          <label class="hours" :id="'seconds_' + crrTimestamp">00</label>
                        </span>
                        <input type="hidden" id="hiddenInput" />
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="pretestFlag">
                    <div class="col-md-12">
                      <h4>{{ pretest.name }}</h4>
                    </div>

                    <!-- Show description first -->
                    <div v-if="showDescriptionStep" class="col-md-12 mb-4">
                      <div class="text-justify course-disc" v-html="pretest.instruction"></div>
                      <div class="btn-sticky-area">
                        <div class="text-right mt-4">
                          <base-button name="Start Test" @click.prevent="startQuestions()" type="primary"
                            class="lesson-btn w-100">Start Test <i class="fa fa-arrow-right"></i></base-button>
                        </div>
                      </div>
                    </div>

                    <!-- Show questions after description -->
                    <div v-else class="col-md-12">
                      <span v-if="pretest.questions && pretest.questions.length > 0">
                        <div class="mt-2">
                          <h6 class="questionname">
                            {{ currentQuestionIndex + 1 }}.
                            {{
                              pretest.questions[currentQuestionIndex].question_text
                            }}
                          </h6>

                          <div v-if="
                            pretest.questions[currentQuestionIndex]
                              .question_type == 1
                          ">
                            <div class="col-md-6" v-if="
                              pretest.questions[currentQuestionIndex]
                                .validation === 1
                            ">
                              <base-input @click.prevent="acceptNumber" placeholder="(555)555-5555" v-model="pretest.questions[currentQuestionIndex]
                                  .selected_answers
                                "></base-input>
                            </div>
                            <div class="col-md-6" v-if="
                              pretest.questions[currentQuestionIndex]
                                .validation === 2
                            ">
                              <base-input name="Email" placeholder="Enter email" type="email" v-model="pretest.questions[currentQuestionIndex]
                                  .selected_answers
                                "></base-input>
                            </div>
                            <div class="col-md-6" v-if="
                              pretest.questions[currentQuestionIndex]
                                .validation === 3
                            ">
                              <base-input type="text" v-model="pretest.questions[currentQuestionIndex]
                                  .selected_answers
                                "></base-input>
                            </div>
                            <div class="col-md-6" v-if="
                              pretest.questions[currentQuestionIndex]
                                .validation === 4
                            ">
                              <base-input placeholder="Enter Date in format MM/DD/YYYY" v-model="pretest.questions[currentQuestionIndex]
                                  .selected_answers
                                " @input="dateFormat(currentQuestionIndex)"></base-input>
                              <small class="text-danger">{{
                                dateFormatError
                                }}</small>
                            </div>
                            <div class="col-md-6" v-if="
                              pretest.questions[currentQuestionIndex]
                                .validation === 5
                            ">
                              <base-input placeholder="Enter SSN" v-model="pretest.questions[currentQuestionIndex]
                                  .selected_answers
                                " @input="maskSSN(currentQuestionIndex)"></base-input>
                            </div>
                          </div>
                          <div v-else>
                            <div :key="option.id" class="qtn-checkbox" v-for="option in pretest.questions[
                              currentQuestionIndex
                            ].options">
                              <input :checked="true" :name="'pretest' +
                                pretest.questions[currentQuestionIndex].id
                                " type="radio" v-bind:value="true" v-model="option.selected_answers" />
                              {{ option.option_text }}
                            </div>
                          </div>
                        </div>
                        <div class="btn-sticky-area">
                          <div class="text-right mt-4 d-flex">
                            <base-button name="Previous" @click.prevent="prevQuestion()" type="primary"
                              class="lesson-btn w-100" v-if="currentQuestionIndex > 0"><i class="fa fa-arrow-left"></i>
                              Previous</base-button>
                            <base-button name="Next" @click.prevent="nextQuestion()" type="primary"
                              class="lesson-btn w-100" v-if="
                                currentQuestionIndex < pretest.questions.length - 1
                              ">Next<i class="fa fa-arrow-right"></i></base-button>
                            <base-button name="Submit Pretest" @click.prevent="savePretest()" type="primary"
                              class="lesson-btn w-100" v-if="
                                currentQuestionIndex === pretest.questions.length - 1
                              ">Submit <i class="fa fa-check"></i></base-button>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>

                  <!--Pre test close-->
                  <div class="row" v-if="!pretestFlag">
                    <div :class="scormFlag ? 'col-md-12' : 'col-md-12'">
                      <div v-if="show_lesson && !pretestFlag && !this.scormFlag">
                        <div class="row" v-if="!showQuizFlag">
                          <div class="col-md-12 mb-2" v-if="
                            open_lesson.video_url !== '' &&
                            open_lesson.video_url !== null
                          ">
                            <div v-if="
                              open_lesson.type == 'video' &&
                              open_lesson.video_url.includes('vimeo')
                            ">
                              <iframe :src="open_lesson.video_url" allow="autoplay; fullscreen; picture-in-picture"
                                allowfullscreen="" frameborder="0" height="400" width="640"></iframe>
                            </div>

                            <div v-else-if="
                              open_lesson.type == 'youtube-video' &&
                              open_lesson.video_url.includes('youtube')
                            ">
                              <iframe :src="open_lesson.video_url" allow="autoplay; fullscreen; picture-in-picture"
                                allowfullscreen="" frameborder="0" height="400" width="640"></iframe>
                            </div>

                            <div v-else-if="
                              open_lesson.type == 'pdf' &&
                              open_lesson.video_url.includes('pdf')
                            ">
                              <adobe-pdf :key="open_lesson.video_url" :url="open_lesson.video_url"
                                path="employee/documents"></adobe-pdf>
                            </div>
                          </div>

                          <div class="col-md-12 mb-2" v-if="open_lesson.type == 'gamification'">
                            <slider animation="fade" :autoplay="autoplay" v-if="open_lesson.gamification.length > 1">
                              <slider-item v-for="(i, index) in open_lesson.gamification" :key="index" style="
                                background-color: #fff;
                                width: 100%;
                                height: 100%;
                                padding: 40px;
                              ">
                                <div class="text-justify course-disc" v-html="open_lesson.gamification[index].content">
                                </div>
                              </slider-item>
                            </slider>
                            <div v-else style="width: 100%; height: 100%; padding: 40px"
                              class="slider text-justify course-disc" v-html="open_lesson.gamification[0].content">
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="text-justify course-disc" v-html="open_lesson.lesson_content"></div>
                          </div>
                          <div class="btn-sticky-area">
                            <div class="">
                              <base-button v-if="open_lesson.timer_status && !nextButtonEnable" disabled type="primary"
                                class="lesson-btn w-100" name="Show Quiz" @click.prevent="showQuiz()">Next <i
                                  class="fa fa-arrow-right"></i></base-button>
                              <base-button v-if="!open_lesson.timer_status && !nextButtonEnable" type="primary"
                                class="lesson-btn w-100" @click.prevent="showQuiz()">Next <i
                                  class="fa fa-arrow-right"></i></base-button>
                              <base-button v-if="!open_lesson.timer_status && nextButtonEnable" name="Show Quiz"
                                type="primary" class="lesson-btn w-100" @click.prevent="showQuiz()">Next <i
                                  class="fa fa-arrow-right"></i></base-button>
                              <base-button name="Show Quiz" v-if="open_lesson.timer_status && nextButtonEnable"
                                type="primary" class="lesson-btn w-100" @click.prevent="showQuiz()">Next <i
                                  class="fa fa-arrow-right"></i></base-button>
                            </div>
                          </div>
                          <div v-if="open_lesson.timer_status && !nextButtonEnable" class="col-md-3"
                            style="padding: 16px;">
                            <b>Completes in:</b>
                          </div>
                          <div v-if="open_lesson.timer_status && !nextButtonEnable" class="col-md-4"
                            style="text-align: center">
                            <circular-count-down-timer :key="open_lesson.id" :initial-value="open_lesson.timer_value"
                              @finish="finished" :stroke-width="3" :seconds-stroke-color="'#24d2fe'"
                              :minutes-stroke-color="'#24d2fe'" :hours-stroke-color="'#24d2fe'"
                              :seconds-fill-color="'#ffffff'" :minutes-fill-color="'#ffffff'"
                              :hours-fill-color="'#ffffff'" :padding="4" :size="65" :hour-label="''" :minute-label="''"
                              :second-label="''" :show-second="true" :show-minute="true" :show-hour="true"
                              :notify-every="'minute'"></circular-count-down-timer>
                          </div>
                        </div>
                        <div v-if="showQuizFlag && open_lesson.quiz_status">
                          <!-- Show quiz description first -->
                          <div v-if="showDescriptionStep">
                            <div class="text-justify course-disc">
                              <div v-html="open_lesson.quiz_instruction"></div>
                            </div>
                            <div class="btn-sticky-area">

                              <div class="d-block">
                                <base-button name="Start Quiz" @click.prevent="startQuestions()" type="primary"
                                  class="w-100 lesson-btn">Start Quiz <i class="fa fa-arrow-right"></i></base-button>
                              </div>
                            </div>
                          </div>

                          <!-- Show quiz questions after description -->
                          <div v-else>
                            <div class="row" id="ques" v-if="
                              open_lesson.questions &&
                              open_lesson.questions.length > 0
                            ">
                              <div class="w-100 mt-2">
                                <div class="mb-1">
                                  <div class="col-md-12 form-inline">
                                    <span class="">
                                      <h6 class="questionname">
                                        {{ currentQuestionIndex + 1 }}.
                                        {{
                                          open_lesson.questions[
                                            currentQuestionIndex
                                          ].question_text
                                        }}
                                      </h6>
                                    </span>
                                    <div class="ml-3"></div>
                                  </div>
                                </div>
                                <div :key="option.id" v-for="(option, o_index) in open_lesson.questions[
                                  currentQuestionIndex
                                ].options">
                                  <div class="col-md-12 qtn-checkbox">
                                    <div class="d-flex left-margin justify-content-between">
                                      <label :for="'test' + option.id" class="qtn-checkbox" :class="{
                                        'lable-style':
                                          open_lesson.questions[currentQuestionIndex]
                                            .selected === option.id,
                                      }">
                                        <span>
                                          {{ option.option_text }}
                                        </span>
                                        <input v-if="
                                          open_lesson.questions[
                                            currentQuestionIndex
                                          ].selected
                                        "
                                        :id="'test' + option.id"
                                        :checked="true" :name="'lesson' +
                                        open_lesson.questions[
                                          currentQuestionIndex
                                        ].id
                                        " :value="option.id" type="radio" v-model="open_lesson.questions[
                                            currentQuestionIndex
                                          ].selected
                                          " v-on:input="
                                          optionChecked(
                                            currentQuestionIndex,
                                            o_index,
                                            option.id
                                          )
                                          " />
                                        <input v-else :checked="false" :name="'lesson' +
                                          open_lesson.questions[
                                            currentQuestionIndex
                                          ].id
                                          "
                                          :id="'test' + option.id"
                                          :value="option.id" type="radio" v-model="open_lesson.questions[
                                            currentQuestionIndex
                                          ].selected
                                          " v-on:input="
                                          optionChecked(
                                            currentQuestionIndex,
                                            o_index,
                                            option.id
                                          )
                                          " />
                                      </label>

                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="btn-sticky-area">
                                <div class="d-flex">
                                  <base-button name="Previous" @click.prevent="prevQuestion()" type="primary"
                                    class="w-100 lesson-btn" v-if="currentQuestionIndex > 0"><i
                                      class="fa fa-arrow-left"></i>
                                    Previous</base-button>
                                  <base-button name="Next" @click.prevent="nextQuestion()" type="primary"
                                    class="w-100 lesson-btn" v-if="
                                      currentQuestionIndex <
                                      open_lesson.questions.length - 1
                                    ">Next <i class="fa fa-arrow-right"></i></base-button>
                                  <base-button name="Submit Lesson" @click.prevent="submitLesson()" type="primary"
                                    class="w-100 lesson-btn" v-if="
                                      currentQuestionIndex ===
                                      open_lesson.questions.length - 1
                                    ">Submit<i class="fa fa-check"></i></base-button>
                                </div>
                              </div>
                            </div>
                            <div v-if="showQuizFlag && open_lesson.result === 1">
                              <div class="col-md-12 text-center">
                                <small class="">You've passed this lesson!</small>
                              </div>
                            </div>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <div class="clearfix"></div>
                          </div>
                        </div>
                        <div v-if="showQuizFlag && !open_lesson.quiz_status">
                          <p>
                            Quiz is not available with this lesson. Click next
                            button to continue.
                          </p>
                        </div>
                      </div>

                      <!-- Surveytest Open --->
                      <div class="row" v-if="surveytestFlag && !this.scormFlag">
                        <div class="col-md-12">
                          <h4>{{ surveytest.name }}</h4>
                        </div>

                        <!-- Show survey description first -->
                        <div v-if="showDescriptionStep" class="col-md-12">
                          <div class="text-justify course-disc" v-html="surveytest.instruction"></div>
                          <div class="btn-sticky-area">
                            <div class="text-right mt-4">
                              <base-button name="Start Survey" @click.prevent="startQuestions()" type="primary"
                                class="w-100 lesson-btn">Start Survey <i class="fa fa-arrow-right"></i></base-button>
                            </div>
                          </div>
                        </div>

                        <!-- Show survey questions after description -->
                        <div v-else class="col-md-12">
                          <span v-if="
                            surveytest.questions &&
                            surveytest.questions.length > 0
                          ">
                            <div>
                              <h6 class="questionname">
                                {{ currentQuestionIndex + 1 }}.
                                {{
                                  surveytest.questions[currentQuestionIndex]
                                    .question_text
                                }}
                              </h6>

                              <div v-if="
                                surveytest.questions[currentQuestionIndex]
                                  .question_type == 1
                              ">
                                <div class="mt-2" v-if="
                                  surveytest.questions[currentQuestionIndex]
                                    .validation === 1
                                ">
                                  <base-input @click.prevent="acceptNumber" placeholder="(555) 555-5555" v-model="surveytest.questions[currentQuestionIndex]
                                      .selected_answers
                                    "></base-input>
                                </div>
                                <div class="mt-2" v-if="
                                  surveytest.questions[currentQuestionIndex]
                                    .validation === 2
                                ">
                                  <base-input name="Email" placeholder="Enter email" type="email" v-model="surveytest.questions[currentQuestionIndex]
                                      .selected_answers
                                    "></base-input>
                                </div>
                                <div class="mt-2" v-if="
                                  surveytest.questions[currentQuestionIndex]
                                    .validation === 3
                                ">
                                  <base-input type="text" v-model="surveytest.questions[currentQuestionIndex]
                                      .selected_answers
                                    "></base-input>
                                </div>
                                <div class="mt-2" v-if="
                                  surveytest.questions[currentQuestionIndex]
                                    .validation === 4
                                ">
                                  <el-date-picker :picker-options="pickerOptions1" value-format="yyyy/MM/dd"
                                    format="MM/dd/yyyy" placeholder="Pick a day" style="width: 100%" type="date"
                                    v-model="surveytest.questions[currentQuestionIndex]
                                        .selected_answers
                                      "></el-date-picker>
                                </div>
                                <div class="col-md-6" v-if="
                                  surveytest.questions[currentQuestionIndex]
                                    .validation === 5
                                ">
                                  <base-input placeholder="Enter SSN" v-model="surveytest.questions[currentQuestionIndex]
                                      .selected_answers
                                    "></base-input>
                                </div>
                              </div>
                              <div  v-else>
                                <label class="qtn-checkbox" :for="option.id" :key="option.id" v-for="option in surveytest.questions[
                                  currentQuestionIndex
                                ].options">
                                <span>{{ option.option_text }}</span>
                                  <input :id="option.id" :checked="true" :name="'surveytest_' +
                                    surveytest.questions[currentQuestionIndex].id
                                    " type="radio" v-bind:value="true" v-model="option.selected_answers" />

                              </label>
                              </div>
                            </div>
                            <div class="btn-sticky-area">
                              <div class="text-right mt-4 d-flex">
                                <base-button name="Previous" @click.prevent="prevQuestion()" type="primary"
                                  class="lesson-btn w-100" v-if="currentQuestionIndex > 0"><i
                                    class="fa fa-arrow-left"></i>
                                  Previous</base-button>
                                <base-button name="Next" @click.prevent="nextQuestion()" type="primary"
                                  class="lesson-btn w-100" v-if="
                                    currentQuestionIndex <
                                    surveytest.questions.length - 1
                                  ">Next <i class="fa fa-arrow-right"></i></base-button>
                                <base-button name="Submit Survey" @click.prevent="saveSurveytest()" type="primary"
                                  class="lesson-btn w-100" v-if="
                                    currentQuestionIndex ===
                                    surveytest.questions.length - 1
                                  ">Submit<i class="fa fa-check"></i></base-button>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>

                      <div class="m-0 w-100" v-if="scormFlag">
                        <scorm-loader :course_id="course_id" :scorm-progress="scormProgress"
                          @save-course-completion="saveCourseCompletion" />
                      </div>
                    </div>

                    <div :class="this.food_safe_online_proctored_exam.classes" v-if="
                      this.food_safe_online_proctored_exam.enable &&
                      this.food_safe_online_proctored_exam.completed != 1
                    ">
                      <a :disabled="food_safe_online_proctored_exam.loader" :href="food_safe_online_proctored_exam.url"
                        class="btn base-button custom-btn btn-default" target="_blank">Schedule Proctored Exam
                        <i name="Schedule Proctored Exam" class="fas fa-spin fa-spinner"
                          v-if="food_safe_online_proctored_exam.loader"></i></a>
                      <span class="service-unavailable" v-if="
                        this.food_safe_online_proctored_exam.errors.length >= 1
                      ">Service Unavailable</span>
                    </div>

                    <!-- <div class="col-md-12" id="msg_top" v-if="show_passed_msg">
                      <CongratulationsSectionMob :certificate_availbility="certificate_availability"
                        :hot_user="hot_user" :its_super_admin="its_super_admin"
                        :next_course_message="next_course_message" :pass_message="pass_message"
                        :practice_test="open_test.practice_test"></CongratulationsSectionMob>
                    </div> -->
                  </div>
                </el-tab-pane>

                <el-tab-pane label="Progress" name="second">
                  <div class="scroll-timeline lessonulLi" v-if="!show_passed_msg && !show_scorm">
                    <side-progress v-if="!its_super_admin" :course_id="course_id" :user_id="user_id"
                      v-on:lessonRedirection="lessonRedirection"></side-progress>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </card>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { DatePicker, Option, Select, Table, TableColumn, Tabs, TabPane, Progress, } from "element-ui";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import Swal from "sweetalert2";
import vueVimeoPlayer from "vue-vimeo-player";
import AdobePdf from "./AdobePdf.vue";
import SideProgress from "./SideProgressMobile.vue";
import CongratulationsSectionMob from "./CongratulationScreenWorkday.vue";
import CircularCountDownTimer from "vue-circular-count-down-timer";
import ScormLoader from "./ScormLoader";
import axios from 'axios';
import EasySlider from "vue-easy-slider";

Vue.use(EasySlider);
Vue.use(vueVimeoPlayer);
Vue.use(CircularCountDownTimer);

export default {
  mixins: [clientPaginationMixin],
  components: {
    AdobePdf,
    SideProgress,
    CongratulationsSectionMob,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ScormLoader,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Progress.name]: Progress,
  },
  data() {
    return {
      baseUrl: this.$baseUrl,
      practiceSubmitDisable: false,
      nextButtonEnable: false,
      height: 400,
      playerReady: false,
      playerEnded: false,
      show_lesson: false,
      show_scorm: false,
      scormFile: "",
      dateFormatError: "",
      scormFlag: false,
      show_test: false,
      testType: "",
      show_passed_msg: false,
      isLoading: false,
      fullPage: true,
      processing: false,
      selected_ids: [],
      submitted: false,

      hot_user: "",
      hot_token: "",
      user_id: "",
      interface: "",
      course_id: "",
      course_name: "",
      next_course: "",
      assignment_gap: "",
      pass_message: "",
      next_course_message: "",
      course_content: "",
      lesson_allowed_attempts: 0,
      user_attempts: 0,
      lessons: [],
      passed_lesson: [],
      passed_test: [],
      tests: [],
      open_lesson_index: -1,
      open_test_index: -1,
      open_lesson: {},
      open_test: {},
      all_tests: [],
      pre_test: [],
      pretest: {},
      surveytest: [],
      formattedPretest: {},
      its_super_admin: false,
      showQuizFlag: false,
      passed_msg: "",
      pretestFlag: false,
      pretest_status: false,
      surveytestFlag: false,
      surveytest_status: false,
      certificate_availability: 0,
      practiceTestResult: {},
      splicedQuestonArray: {},
      remainingQuestionPraticeTest: [],
      finishedPracticeTest: false,
      originalArray: [],
      sliceStart: 0,
      start: 1,
      end: 1,
      examResult: 0,
      correctQuestions: 0,
      incorrectQuestions: 0,
      correctAnswer: "",
      is_last_lesson: "",
      food_safe_online_proctored_exam: {
        enable: 0,
        loader: true,
        url: "",
        completed: 0,
        errors: [],
        classes: "exam-button-wrapper",
      },
      pickerOptions1: {},
      totalSeconds: "",
      hoursLabel: "",
      minutesLabel: "",
      secondsLabel: "",
      totalMinutes: 0,
      crrTimestamp: Math.floor(Date.now()),
      autoplay: false,
      studentData: null,
      scormProgress: null,
      isScormCompleted: false,
      // Add new property for question navigation
      currentQuestionIndex: 0,
      // Add new property to control showing description first
      showDescriptionStep: true,
      apiConfig: {
        headers: {
          'Authorization': `Bearer ${this.$route.query.token || ''}`
        }
      },
      timerInterval: null, // Store the interval reference
      activeName: "first",
    };
  },
  computed: {
    // Calculate total questions based on current context
    getTotalQuestions() {
      if (this.pretestFlag && this.pretest.questions) {
        return this.pretest.questions.length;
      } else if (this.show_test && this.open_test.questions) {
        return this.open_test.questions.length;
      } else if (this.show_lesson && this.showQuizFlag && this.open_lesson.questions) {
        return this.open_lesson.questions.length;
      } else if (this.surveytestFlag && this.surveytest.questions) {
        return this.surveytest.questions.length;
      }
      return 0;
    },
    // Calculate progress percentage for progress bar
    progressPercentage() {
      if (this.getTotalQuestions === 0) return 0;
      return Math.round(((this.currentQuestionIndex + 1) / this.getTotalQuestions) * 100);
    },
    getWindowHeight: function () {
      return window.innerHeight + "px";
    },
  },

  beforeRouteLeave(to, from, next) {
    if (!this.its_super_admin) {
      this.updateTimerValue();
    }
    next();
  },
  created: async function () {
    this.isLoading = true;

    // Get user info from route query params
    this.hot_user = this.$route.query.userType || '';
    this.hot_token = this.$route.query.token || '';
    this.user_id = this.$route.query.userId || '';

    if (this.$route.query.id) {
      this.course_id = this.$route.query.id;

      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.hot_token}`;

      try {
        // Send only the specific header and token
        const response = await axios.get(`${this.$baseUrl}/employees/scorm-progress`, {
          headers: {
            Authorization: `Bearer ${this.hot_token}`
          },
          params: {
            courseId: this.course_id,
          }
        });

        this.scormProgress = response.data;
      } catch (error) {
        console.error('Error fetching SCORM progress:', error);
      }

      this.getData();
    }

    if (this.$route.query.interface) {
      this.interface = "company";
    }
    if (this.$route.query.super_admin) {
      this.its_super_admin = true;
    }
  },
  mounted() {
    var test = window.addEventListener("beforeunload", this.updateTimerValue);
    setInterval(this.setTime, 1000);

    const picker = this.$refs.elDatePicker
    if (picker && picker.$el) {
      picker.$el.onkeydown = (ev) => {
        console.log(1);
      }
    }
    this.timerInterval = setInterval(() => {
      this.updateTimerValue();
    }, 15000);
  },
  beforeUnmount() {
    // Clear the interval when the component is destroyed
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
  methods: {
    onBackClick() {
      console.log("Back button clicked");
    // If using webview_flutter:
    if (window.FlutterChannel) {
      window.FlutterChannel.postMessage('goBack');
    }
    // Fallback for inappwebview plugin:
    else if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('goBack');
    }
  },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // Add method to start showing questions after description
    startQuestions() {
      this.showDescriptionStep = false;
      this.currentQuestionIndex = 0;
    },

    // Add new methods for question navigation
    // nextQuestion() {
    //   if (this.pretestFlag && this.currentQuestionIndex < this.pretest.questions.length - 1) {
    //     this.currentQuestionIndex++;
    //   } else if (this.show_lesson && this.showQuizFlag && this.currentQuestionIndex < this.open_lesson.questions.length - 1) {
    //     this.currentQuestionIndex++;
    //   } else if (this.show_test && this.currentQuestionIndex < this.open_test.questions.length - 1) {
    //     this.currentQuestionIndex++;
    //   } else if (this.surveytestFlag && this.currentQuestionIndex < this.surveytest.questions.length - 1) {
    //     this.currentQuestionIndex++;
    //   }
    // },
    nextQuestion() {
// Check if the current question has an answer before proceeding
let hasAnswer = false;
let currentQuestion = null;

if (this.pretestFlag && this.currentQuestionIndex < this.pretest.questions.length - 1) {
  currentQuestion = this.pretest.questions[this.currentQuestionIndex];
  // Check if text input has value or any option is selected
  if (currentQuestion.question_type == 1) {
    hasAnswer = currentQuestion.selected_answers && currentQuestion.selected_answers.trim() !== '';
  } else {
    hasAnswer = currentQuestion.options.some(option => option.selected_answers);
  }

  if (!hasAnswer) {
    Swal.fire({
      title: "Error!",
      text: "Please answer the question before proceeding.",
      icon: "error",
      confirmButtonClass: 'btn btn-success',
    });
    return;
  }
  this.currentQuestionIndex++;
} else if (this.show_lesson && this.showQuizFlag && this.currentQuestionIndex < this.open_lesson.questions.length - 1) {
  currentQuestion = this.open_lesson.questions[this.currentQuestionIndex];
  hasAnswer = currentQuestion.selected !== undefined && currentQuestion.selected !== '';

  if (!hasAnswer) {
    Swal.fire({
      title: "Error!",
      text: "Please select an answer before proceeding.",
      icon: "error",
      confirmButtonClass: 'btn btn-success',
    });
    return;
  }
  this.currentQuestionIndex++;
} else if (this.show_test && this.currentQuestionIndex < this.open_test.questions.length - 1) {
  currentQuestion = this.open_test.questions[this.currentQuestionIndex];
  hasAnswer = currentQuestion.selected !== undefined && currentQuestion.selected !== '';

  if (!hasAnswer) {
    Swal.fire({
      title: "Error!",
      text: "Please select an answer before proceeding.",
      icon: "error",
      confirmButtonClass: 'btn btn-success',
    });
    return;
  }
  this.currentQuestionIndex++;
} else if (this.surveytestFlag && this.currentQuestionIndex < this.surveytest.questions.length - 1) {
  currentQuestion = this.surveytest.questions[this.currentQuestionIndex];
  // Check if text input has value or any option is selected
  if (currentQuestion.question_type == 1) {
    hasAnswer = currentQuestion.selected_answers && currentQuestion.selected_answers.trim() !== '';
  } else {
    hasAnswer = currentQuestion.options.some(option => option.selected_answers);
  }

  if (!hasAnswer) {
    Swal.fire({
      title: "Error!",
      text: "Please answer the question before proceeding.",
      icon: "error",
      confirmButtonClass: 'btn btn-success',
    });
    return;
  }
  this.currentQuestionIndex++;
}
},

    prevQuestion() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
      }
    },

    getCookie: function (cname) {
      let name = cname + "=";
      let decodedCookie = document.cookie;
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + ";";
    },
    updateTimerValue() {
      if (this.show_scorm) {
        return true;
      }
      let data = {
        hour_time: document.getElementById("hours_" + this.crrTimestamp).innerHTML,
        min_time: document.getElementById("minutes_" + this.crrTimestamp).innerHTML,
        sec_time: document.getElementById("seconds_" + this.crrTimestamp).innerHTML,
        course_id: this.course_id,
        employee_id: this.user_id,
      };
      axios.post(`${this.$baseUrl}/course/updateTimerValue`, data, {
        headers: {
          Authorization: `Bearer ${this.hot_token}`, // Ensure token is included
          'Content-Type': 'application/json',
        }
      })
        .then((resp) => {
          console.log("Timer updated successfully");
        })
        .catch((error) => {
          console.error("Error updating timer:", error);
        });
    },
    setTime() {
      this.hoursLabel = document.getElementById("hours_" + this.crrTimestamp);
      this.minutesLabel = document.getElementById("minutes_" + this.crrTimestamp);
      this.secondsLabel = document.getElementById("seconds_" + this.crrTimestamp);
      ++this.totalSeconds;

      if (this.secondsLabel) {
        this.secondsLabel.innerHTML = this.pad(this.totalSeconds % 60);
        document.getElementById("hiddenInput").value = this.secondsLabel.innerHTML;
      }
      this.totalMinutes = this.totalSeconds / 60;
      if (this.minutesLabel) {
        this.minutesLabel.innerHTML = this.pad(parseInt(this.totalMinutes % 60));
      }
      if (this.hoursLabel) {
        this.hoursLabel.innerHTML = this.pad(parseInt(this.totalSeconds / 3600));
      }
    },
    pad(val) {
      var valString = val + "";
      if (valString.length < 2) {
        return "0" + valString;
      } else {
        return valString;
      }
    },
    setDate(evt) {
      var el = document.getElementById("dateField");
      if ((evt.keyCode >= 48 && evt.keyCode <= 57) || (evt.keyCode >= 96 && evt.keyCode <= 105)) {
        evt = evt || window.event;

        var size = document.getElementById("dateField").value.length;

        if ((size == 2 && document.getElementById("dateField").value > 12) || (size == 5 && Number(document.getElementById("dateField").value.split("/")[1]) > 31) || (size == 10 && Number(document.getElementById("dateField").value.split("/")[2]) > new Date().getFullYear())) {
          alert("Invalid Date");
          document.getElementById("dateField").value = "";
          return;
        }

        if ((size == 2 && document.getElementById("dateField").value < 13) || (size == 5 && Number(document.getElementById("dateField").value.split("/")[1]) < 32)) {
          document.getElementById("dateField").value += "/";
        }
      }
    },
    finished() {
      this.nextButtonEnable = true;
    },
    showLesson() {
      this.pretestFlag = false;
    },
    backQuiz() {
      try {
        if (this.open_lesson_index - 1 >= 0) {
          this.open_lesson = this.lessons[this.open_lesson_index - 1];
          if (this.open_lesson.quiz_status && !this.open_lesson.result) {
            this.showQuizFlag = true;
          } else if ((this.open_lesson.quiz_status || !this.open_lesson.quiz_status) && this.open_lesson.result) {
            if (this.lessons.length > this.open_lesson_index - 1) {
              this.open_lesson_index--;
            } else {
              if (this.open_test_index >= 0) {
                this.show_test = true;
                this.show_lesson = false;
              }
              this.open_lesson_index = this.lessons.length + 1;
            }
            const open_lesson_data1 = this.lessons[Math.abs(this.open_lesson_index)];
            this.open_lesson = open_lesson_data1;
          } else {
            this.formattedLessontest = {
              is_last_lesson: this.is_last_lesson,
              course_id: this.course_id,
              test_id: this.open_lesson.id,
              test_type: "lesson",
              questions: [],
            };
            this.testType = "lesson";
            this.submitAnswers(this.formattedLessontest, this.testType);
          }
        }
        // Reset current question index and show description first when changing lessons
        this.currentQuestionIndex = 0;
        this.showDescriptionStep = true;
      } catch (error) {
        console.log("error", error);
      }
    },
    backTest() {
      try {
        this.open_lesson = this.lessons[this.lessons.length - 1];
        this.show_lesson = true;
        this.show_test = false;
        this.open_lesson_index = this.lessons.length - 1;
        // Reset current question index and show description first when changing to lesson
        this.currentQuestionIndex = 0;
        this.showDescriptionStep = true;
      } catch (error) {
        console.log("error", error);
      }
    },
    showQuiz() {
      try {
        if (this.open_lesson.quiz_status && !this.open_lesson.result) {
          this.showQuizFlag = true;
          // Reset to show description first when showing quiz
          this.showDescriptionStep = true;
        } else if ((this.open_lesson.quiz_status || !this.open_lesson.quiz_status) && this.open_lesson.result) {
          if (this.lessons.length > this.open_lesson_index + 1) {
            this.open_lesson_index++;
          } else {
            if (this.open_test_index >= 0) {
              this.show_test = true;
              this.show_lesson = false;
              // Reset to show description first when showing test
              this.showDescriptionStep = true;
            }
            this.open_lesson_index = this.lessons.length - 1;
          }
          const open_lesson_data1 = this.lessons[Math.abs(this.open_lesson_index)];
          this.open_lesson = open_lesson_data1;
        } else {
          this.formattedLessontest = {
            is_last_lesson: this.is_last_lesson,
            course_id: this.course_id,
            test_id: this.open_lesson.id,
            test_type: "lesson",
            questions: [],
          };
          this.testType = "lesson";
          this.submitAnswers(this.formattedLessontest, this.testType);
        }
        // Reset current question index when showing quiz
        this.currentQuestionIndex = 0;
      } catch (error) {
        console.log("error", error);
      }
    },
    acceptNumber() {
    },
    savePretest() {
      this.formattedPretest = {
        course_id: this.course_id,
        test_id: this.pretest.id,
        test_type: "pre_test",
        questions: [],
      };
      for (let quest of this.pretest.questions) {
        let question_obj = {
          question_id: quest.id,
          question: quest.question_text,
          answer: "",
          answer_id: "0",
        };
        if (quest.selected_answers == null || quest.selected_answers == "") {
          for (let option of quest.options) {
            if (option.selected_answers) {
              question_obj.answer = option.option_text;
              question_obj.answer_id = option.id;
            }
          }
        } else {
          question_obj.answer = quest.selected_answers;
        }
        this.formattedPretest.questions.push(question_obj);
      }
      axios.post(`${this.$baseUrl}/course/employeeAnswer`, this.formattedPretest, {
        headers: {
          Authorization: `Bearer ${this.hot_token}`,
          'Content-Type': 'application/json',
        }
      })
        .then((resp) => {
          this.pretestFlag = false;
          // Reset current question index and show description first when finishing pretest
          this.currentQuestionIndex = 0;
          this.showDescriptionStep = true;
        })
        .catch(function (error) {
          if (error.response.status === 422) {
            return Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
            });
          }
        });
    },
    saveSurveytest() {
      this.formattedSurveytest = {
        course_id: this.course_id,
        test_id: this.surveytest.id,
        test_type: "survey",
        questions: [],
      };
      for (let quest of this.surveytest.questions) {
        let question_obj = {
          question_id: quest.id,
          question: quest.question_text,
          answer: "",
          answer_id: "0",
        };
        if (quest.selected_answers == null || quest.selected_answers == "") {
          for (let option of quest.options) {
            if (option.selected_answers) {
              question_obj.answer = option.option_text;
              question_obj.answer_id = option.id;
            }
          }
        } else {
          question_obj.answer = quest.selected_answers;
        }
        this.formattedSurveytest.questions.push(question_obj);
      }
      axios.post(`${this.$baseUrl}/course/employeeAnswer`, this.formattedSurveytest, {
        headers: {
          Authorization: `Bearer ${this.hot_token}`,
          'Content-Type': 'application/json',
        }
      })
        .then((resp) => {
          this.surveytestFlag = false;
          // Reset current question index and show description first when finishing survey
          this.currentQuestionIndex = 0;
          this.showDescriptionStep = true;
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Survey Submitted Succesfully !",
            confirmButtonClass: "btn btn-success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.showPassedMsg();
            }
          });
        })
        .catch(function (error) {
          if (error.response.status === 422) {
            return Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
              confirmButtonClass: 'btn btn-success',
            });
          }
        });
    },
    getData() {
      axios.post(`${this.$baseUrl}/course/full_data`, {
        course_id: this.course_id,
        user_id: this.user_id,
      }, {
        headers: {
          Authorization: `Bearer ${this.hot_token}`,
          'Content-Type': 'application/json',
        }
      })
        .then((resp) => {
          this.pretest_status = resp.data[0].pretest_status;
          this.course_name = resp.data[0].name;
          this.next_course = resp.data[0].next_course;
          this.assignment_gap = resp.data[0].assignment_gap;
          this.pass_message = resp.data[0].pass_message;
          this.certificate_availability = resp.data[0].certificate_available;
          this.remaining_attempts = resp.data[0].allow_attempts;
          this.passing_percent = resp.data[0].passing_percent;
          let lessons = resp.data[0].lessons;
          this.all_tests = resp.data[0].tests;
          let pretest = resp.data[0].pretest;
          let surveytest = resp.data[0].survey;
          this.totalSeconds = resp.data[0].timer_value;
          this.show_scorm = resp.data[0].is_scorm;
          this.scormFile = resp.data[0].scorm_file;

          if (this.show_scorm) {
            this.scormFlag = true;
          }

          if (resp.data[0].pretest.length > 0) {
            this.scormFlag = false;
            this.pretestFlag = true;
          }

          if (resp.data[0].pretest != "" && !this.pretest_status) {
            this.pretestFlag = true;

            let obj = {
              id: pretest.id,
              name: pretest.name,
              test_type: "pre_test",
              instruction: pretest.instruction,
              questions: [],
            };
            let questions = pretest.questions;
            for (let quest of questions) {
              let question_obj = {
                id: quest.id,
                pass: false,
                question_text: quest.question,
                question_type: quest.question_type,
                validation: quest.validation,
                status: false,
                selected_answers: "",
                options: [],
              };
              if (quest.status) {
                question_obj.status = true;
              } else {
                question_obj.status = false;
              }
              let options = quest.answers;
              for (let opt of options) {
                let opt_obj = {
                  id: opt.id,
                  selected_answers: false,
                  option_text: opt.answer,
                };
                question_obj.options.push(opt_obj);
              }
              obj.questions.push(question_obj);
            }
            this.pretest = obj;
          }

          for (let test of surveytest) {
            this.surveytestFlag = false;
            if (test != null || test != "") {
              this.surveytest_status = true;
            }
            let obj = {
              id: test.id,
              name: test.name,
              test_type: "survey",
              instruction: test.instruction,
              questions: [],
            };
            let questions = test.questions;
            for (let quest of questions) {
              let question_obj = {
                id: quest.id,
                pass: false,
                question_text: quest.question,
                question_type: quest.question_type,
                validation: quest.validation,
                status: false,
                selected_answers: "",
                options: [],
              };
              if (quest.status) {
                question_obj.status = true;
              } else {
                question_obj.status = false;
              }
              let options = quest.answers;
              for (let opt of options) {
                let opt_obj = {
                  id: opt.id,
                  selected_answers: false,
                  option_text: opt.answer,
                };
                question_obj.options.push(opt_obj);
              }
              obj.questions.push(question_obj);
            }
            this.surveytest = obj;
          }
          for (let lesson of lessons) {
            let obj = {
              id: lesson.id,
              name: lesson.course_lesson_name,
              allowed_attempts: lesson.allowed_attempts,
              remaining_attempts: lesson.remaining_attempts,
              type: lesson.type,
              video_url: lesson.course_lesson_video,
              is_last_lesson: lesson.is_last_lesson,
              timer_status: lesson.timer_status,
              timer_value: lesson.timer_value_insec,
              lesson_content: lesson.course_lesson_content,
              quiz_instruction: lesson.course_lesson_quiz,
              quiz_status: lesson.quiz_status,
              result: lesson.result,
              gamification: "",
              questions: [],
            };
            if (obj.type == "gamification") {
              this.$http
                .post(
                  "course/gamification_data",
                  {
                    course_id: this.course_id,
                    lesson_id: obj.id,
                  },
                  this.apiConfig
                )
                .then((resp) => {
                  obj.gamification = resp.data;
                });
            }
            let questions = lesson.questions;
            for (let quest of questions) {
              let question_obj = {
                id: quest.id,
                pass: false,
                question_text: quest.question,
                attempts: quest.allowed_attempts,
                allowed_attempts: quest.allowed_attempts,
                status: false,
                correct_answers: "",
                selected_answers: [],
                options: [],
              };
              if (quest.status) {
                question_obj.status = true;
              } else {
                question_obj.status = false;
              }
              let options = quest.answers;
              for (let opt of options) {
                if (opt.course_quiz_correct_answer) {
                  question_obj.correct_answers = opt.id;
                }
                let opt_obj = {
                  id: opt.id,
                  selected_answers: false,
                  option_text: opt.course_quiz_question_option,
                };
                question_obj.options.push(opt_obj);
              }
              obj.questions.push(question_obj);
            }
            this.lessons.push(obj);

            if (!obj.result && this.open_lesson_index < 0) {
              this.open_lesson_index = lessons.indexOf(lesson);
            }
          }
          if (this.$route.query.redirection === "yes") {
            this.lessonRedirection(
              parseInt(this.$route.query.lesson_id),
              this.$route.query.type
            );
          }
          if (this.open_lesson_index >= 0) {
            this.show_lesson = true;
            this.open_lesson = this.lessons[this.open_lesson_index];
            this.is_last_lesson = this.open_lesson.is_last_lesson;
          } else if (!this.scormFlag) {
            this.getTest();
          }

          this.food_safe_online_proctored_exam.enable = resp.data[0].food_safe_online_proctored_exam;
          if (this.food_safe_online_proctored_exam.enable) {
            this.$http
              .post("course/proctored-exam", {
                course_id: this.course_id,
              }, this.apiConfig)
              .then((resp) => {
                if (resp.data.url) {
                  this.food_safe_online_proctored_exam.url = resp.data.url;
                  this.food_safe_online_proctored_exam.completed = resp.data.completed;
                  this.food_safe_online_proctored_exam.loader = false;
                } else {
                  this.food_safe_online_proctored_exam.errors = resp.data.errors;
                  this.food_safe_online_proctored_exam.classes = "exam-button-wrapper has-errors";
                }
              });
          }
        });

      if (this.show_scorm) {
        this.$http.get('/employees/check-for-scorm-completion', {
          params: {
            courseId: this.course_id,
          },
          headers: {
            'Authorization': `Bearer ${this.hot_token}`
          }
        }).then(response => {
          this.scormFlag = (response.data.scormPassed == 1) ? false : true;
          if (this.pretestFlag == false && this.show_test == false && this.scormFlag == false) {
            this.show_passed_msg = true;
          }
        });
      }
    },
    lessonRedirection(lesson_id, type) {
      this.activeName='first';
      if (type == "lesson") {
        const open_lesson_data = this.lessons.filter((obj) => {
          return obj.id == lesson_id;
        });

        this.show_test = false;
        this.show_lesson = true;
        this.open_lesson = open_lesson_data[0];

        this.open_lesson_index = this.lessons.findIndex((x) => x.id === lesson_id);

        this.showQuizFlag = false;
      } else if (type == "test") {
        const open_test_data = this.tests.filter((obj) => {
          return obj.id == lesson_id;
        });
        this.show_test = true;
        this.show_lesson = false;
        this.open_test = open_test_data[0];
        this.open_test_index = this.tests.findIndex((x) => x.id === lesson_id);
        this.showQuizFlag = false;
      }
      // Reset current question index and show description first when redirecting
      this.currentQuestionIndex = 0;
      this.showDescriptionStep = true;
    },
    getTest() {
      if (this.all_tests.length <= 0) {
        if (this.surveytest_status) {
          this.surveytestFlag = true;
        } else {
          this.showPassedMsg();
        }
      }
      for (let test of this.all_tests) {
        let obj = {
          id: test.id,
          practice_test: test.practice_test,
          enable_submit: test.enable_submit_button,
          is_last_lesson: test.is_last_lesson,
          passed_msg: test.course_test_pass_msg,
          allowed_attempts: test.allowed_attempts,
          remaining_attempts: test.remaining_attempts,
          quiz_instruction: test.course_test_instruction,
          employee_saved_practice_count: test.employee_saved_practice_test,
          result: test.result,
          pageno: Math.ceil(test.employee_saved_practice_count / test.enable_submit_button) > 0 ? Math.ceil(test.employee_saved_practice_count / test.enable_submit_button) : 1,
          questions: [],
        };

        let questions = test.questions;
        var srl = 1;
        for (let quest of questions) {
          let question_obj = {
            sr_no: srl,
            id: quest.id,
            pass: false,
            question_text: quest.question,
            attempts: quest.allowed_attempts,
            allowed_attempts: quest.allowed_attempts,
            status: false,
            correct_answers: "",
            selected_answers: [],
            options: [],
          };
          if (quest.draft_answer_id) {
            question_obj.selected = quest.draft_answer_id;
          }
          if (quest.status) {
            question_obj.status = true;
          } else {
            question_obj.status = false;
          }
          let options = quest.answers;
          for (let opt of options) {
            if (opt.course_quiz_correct_answer) {
              question_obj.correct_answers = opt.id;
            }
            let opt_obj = {
              id: opt.id,
              selected_answers: false,
              option_text: opt.course_quiz_question_option,
            };
            question_obj.options.push(opt_obj);
          }
          obj.questions.push(question_obj);
          srl++;
        }

        this.tests.push(obj);

        if (!obj.result && this.open_test_index < 0) {
          this.open_test_index = this.all_tests.indexOf(test);
        }
      }
      if (this.open_test_index >= 0) {
        this.show_test = true;
        this.show_lesson = false;
        this.pretestFlag = false;
        this.show_passed_msg = false;
        this.submitted = false;
        this.open_test = this.tests[this.open_test_index];

        if (this.open_test.practice_test) {
          this.sliceStart = (this.open_test.pageno - 1) * this.open_test.enable_submit;
          this.start = this.open_test.pageno * this.open_test.enable_submit;
          this.end = this.start + this.open_test.enable_submit;
          this.originalArray = this.open_test.questions;
          this.splicedQuestonArray = this.open_test.questions.slice(this.sliceStart, this.open_test.enable_submit + this.sliceStart);
          this.open_test.questions = this.splicedQuestonArray;
        }
        this.is_last_lesson = this.open_test.is_last_lesson;
        // Reset current question index and show description first when showing test
        this.currentQuestionIndex = 0;
        this.showDescriptionStep = true;
      } else {
        if (this.surveytest_status) {
          this.surveytestFlag = true;
        } else {
          this.showPassedMsg();
        }
      }
    },
    refershPracticeTest() {
      this.practiceSubmitDisable = false;
      let page = this.open_test.pageno++;
      if (this.originalArray.length !== this.end) {
        if (this.sliceStart > 0) {
          this.start = page * this.open_test.enable_submit;
          this.end = this.start + this.open_test.enable_submit;
        } else {
          this.start = parseInt(this.sliceStart) + parseInt(this.open_test.enable_submit);
          this.end = parseInt(this.open_test.enable_submit) + parseInt(this.open_test.enable_submit);

          this.sliceStart++;
        }
        if (this.end > this.originalArray.length) {
          this.end = this.originalArray.length;
        }
        this.open_test.questions = this.originalArray.slice(this.start, this.end);
        // Reset current question index and show description first when refreshing practice test
        this.currentQuestionIndex = 0;
        this.showDescriptionStep = true;
      } else {
        this.finishedPracticeTest = true;
      }
    },
    showPassedMsg() {

          this.show_lesson = false;
          this.show_test = false;
          this.scormFlag = false;
          this.show_passed_msg = true;


    },

    submitLesson() {
      this.formattedLessontest = {
        is_last_lesson: this.is_last_lesson,
        course_id: this.course_id,
        user_id: this.user_id,
        test_id: this.open_lesson.id,
        test_type: "lesson",
        questions: [],
      };
      for (let quest of this.open_lesson.questions) {
        let question_obj = {
          question_id: quest.id,
          question: quest.question_text,
          answer: "",
          currect_answer_id: quest.correct_answers,
          answer_id: 0,
          selected: quest.selected,
        };
        for (let option of quest.options) {
          if (option.id == question_obj.selected) {
            question_obj.answer = option.option_text;
            question_obj.answer_id = option.id;
          }
        }
        this.formattedLessontest.questions.push(question_obj);
      }
      this.testType = "lesson";
      this.submitAnswers(this.formattedLessontest, this.testType);
    },
    optionChecked(q_index, o_index, val) {
      this.open_lesson.questions[q_index].selected_answers = [];
      this.open_lesson.questions[q_index].selected_answers.push(val);
    },
    optionTestChecked(q_index, o_index, val) {
      this.open_test.questions[q_index].selected_answers = [];
      this.open_test.questions[q_index].selected_answers.push(val);
    },
    mergeArrayObjects(arr1, arr2) {
      return arr1.map((item, i) => {
        if (item.question_id === arr2[i].question_id) {
          return Object.assign({}, item, arr2[i]);
        }
      });
    },
    draftPracticeTest() {
      var selectedTrue = false;
      for (let selectquest of this.open_test.questions) {
        if (selectquest.selected) {
          selectedTrue = true;
        }
      }
      if (!selectedTrue) {
        return Swal.fire({
          title: "Error!",
          text: "Please select option(s) to continue.",
          icon: "error",
          confirmButtonClass: 'btn btn-success',
        });
      } else {
        this.formattedtest = {
          course_id: this.course_id,
          user_id: this.user_id,
          test_id: this.open_test.id,
          test_type: "practice test",
          questions: [],
        };
        for (let quest of this.open_test.questions) {
          let question_obj = {
            question_id: quest.id,
            selected: quest.selected ? quest.selected : "",
          };
          this.formattedtest.questions.push(question_obj);
        }

        axios.post(`${this.$baseUrl}/course/savePracticeTestDraft`, this.formattedtest, {
          headers: {
            Authorization: `Bearer ${this.hot_token}`,
            'Content-Type': 'application/json',
          }
        })
          .then((resp) => {
            Swal.fire({
              title: "Success!",
              text: "Practice test saved successfully.",
              icon: "success",
              confirmButtonClass: 'btn btn-success',
            });
          })
          .catch(function (error) {
            if (error.response.status === 422) {
              return Swal.fire({
                title: "Error!",
                text: error.response.data.message,
                icon: "error",
                confirmButtonClass: 'btn btn-success',
              });
            }
          });
      }
    },
    practiceTestFinish() {
      this.formattedtest = {
        course_id: this.course_id,
        user_id: this.user_id,
        test_id: this.open_test.id,
        test_type: "practice test",
        questions: [],
      };
      axios.post(`${this.$baseUrl}/course/practiceTestAnswers`, this.formattedtest, {
        headers: {
          Authorization: `Bearer ${this.hot_token}`,
          'Content-Type': 'application/json',
        }
      }).then((resp) => {
        console.log("DONE");
      });
    },
    submitPracticeTest() {
      this.correctQuestions = 0;
      this.incorrectQuestions = 0;
      for (let selectquest of this.open_test.questions) {
        if (!selectquest.selected) {
          return Swal.fire({
            title: "Error!",
            text: "Please select option(s) to continue.",
            icon: "error",
            confirmButtonClass: 'btn btn-success',
          });
        }
      }
      this.practiceSubmitDisable = true;
      this.selectedanswers = [];
      this.formattedtest = {
        course_id: this.course_id,
        user_id: this.user_id,
        test_id: this.open_test.id,
        test_type: "practice test",
        questions: [],
      };
      this.saveformattedtest = {
        course_id: this.course_id,
        user_id: this.user_id,

        test_id: this.open_test.id,
        test_type: "practice test",
        questions: [],
      };
      for (let quest of this.open_test.questions) {
        let question_obj = {
          question_id: quest.id,
          //selected: quest.selected
        };
        let question_obj1 = {
          question_id: quest.id,
          selected: quest.selected,
        };
        this.saveformattedtest.questions.push(question_obj1);
        this.formattedtest.questions.push(question_obj);
        this.selectedanswers.push(question_obj1);
      }

      this.selectedanswers.sort(function (a, b) {
        return parseInt(a.question_id) - parseInt(b.question_id);
      });

      this.loading = true;
      axios.post(`${this.$baseUrl}/course/practiceTestAnswers`, this.formattedtest, {
        headers: {
          Authorization: `Bearer ${this.hot_token}`,
          'Content-Type': 'application/json',
        }
      })
        .then((resp) => {
          resp.data.sort(function (a, b) {
            return parseInt(a.question_id) - parseInt(b.question_id);
          });

          this.practiceTestResult = this.mergeArrayObjects(this.selectedanswers, resp.data);

          this.practiceTestResult.forEach((item) => {
            let cAnswer = item.question_id + "_" + item.correct_answer;
            let sAnswer = item.question_id + "_" + item.selected;

            if (cAnswer === sAnswer) {
              this.correctQuestions++;
              document.getElementById(cAnswer).classList.add("correct");
              document.getElementById("correct_" + item.question_id).style.display = "inline-block";
            } else {
              this.incorrectQuestions++;
              document.getElementById(cAnswer).classList.add("correct");
              document.getElementById(sAnswer).classList.add("wrong");
              document.getElementById("incorrect_" + item.question_id).style.display = "inline-block";
            }
          });
          if (this.correctQuestions >= this.incorrectQuestions) {
            document.getElementById("styleResultId").style.color = "green";
          } else {
            document.getElementById("styleResultId").style.color = "red";
          }
        })
        .catch(function (error) {
          if (error.response.status === 422) {
            Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
              confirmButtonClass: 'btn btn-success',
            });
          }
        })
        .finally(() => (this.loading = false));

      axios.post(`${this.$baseUrl}/course/savePracticeTestDraft`, this.saveformattedtest, {
        headers: {
          Authorization: `Bearer ${this.hot_token}`,
          'Content-Type': 'application/json',
        }
      }).then((resp) => {
        console.log("DONE");
      });
    },
    submitTest() {
      this.formattedtest = {
        is_last_lesson: this.is_last_lesson,
        course_id: this.course_id,
        user_id: this.user_id,
        test_id: this.open_test.id,
        test_type: "test",
        questions: [],
      };
      if(this.is_last_lesson == 1){
        this.formattedtest.redirection = true;
      }
      var srl = 1;
      for (let quest of this.open_test.questions) {
        let question_obj = {
          sr_no: srl,
          question_id: quest.id,
          question: quest.question_text,
          answer: "",
          currect_answer_id: quest.correct_answers,
          answer_id: 0,
          selected: quest.selected,
        };
        for (let option of quest.options) {
          if (option.id == question_obj.selected) {
            question_obj.answer = option.option_text;
            question_obj.answer_id = option.id;
          }
        }
        this.formattedtest.questions.push(question_obj);
        srl++;
      }
      this.testType = "test";
      this.submitAnswers(this.formattedtest, this.testType);
    },
    submitAnswers(formattedtest, test_type) {
      axios.post(`${this.$baseUrl}/course/employeeAnswer`, formattedtest, {
        headers: {
          Authorization: `Bearer ${this.hot_token}`,
          'Content-Type': 'application/json',
        }
      })
        .then((resp) => {
          this.pretestFlag = false;
          if (resp.data.redirect_url) {
              window.location.href = resp.data.redirect_url;
          }

      //     if (resp.data.redirection_data) {
      //   // You can format HTML for display, or use your own component/modal here
      //   let d = resp.data.redirection_data;
      //   Swal.fire({
      //     title: "Course Completion Info",
      //     html: `
      //       <b>Employee Email:</b> ${d.employeeEmail}<br>
      //       <b>Employee ID:</b> ${d.employeeId}<br>
      //       <b>Course:</b> ${d.courseName} (#${d.courseId})<br>
      //       <b>Status:</b> ${d.status}<br>
      //       <b>Completion Time:</b> ${d.completionTime || '-'}<br>
      //       <b>Certificate:</b> <a href="${d.certificateUrl}" target="_blank">Download</a>
      //     `,
      //     icon: "info",
      //     confirmButtonClass: "btn btn-success",
      //     confirmButtonText: "OK",
      //     allowOutsideClick: false,
      //     allowEscapeKey: false,
      //   });
      //   // You may want to return here if you don't want the rest of logic to run
      //   // return;
      // }
          if (test_type == "test") {
            if (resp.data.data) {
              let totalAttempts =
                resp.data.data.total_attempts - resp.data.data.attempts;
              if (isNaN(totalAttempts)) {
                this.open_test.remaining_attempts = 0;
              } else {
                this.open_test.remaining_attempts = totalAttempts;
              }
            }

            if (resp.data.status == 1) {
              this.show_test = false;
              if (this.surveytest_status) {
                this.surveytestFlag = true;

                // Reset to show description first when showing survey
                this.showDescriptionStep = true;
              }
              // Otherwise, do final pass or next steps
              else {
                this.show_passed_msg = true;
                this.pretestFlag = false;
                this.scormFlag = false;
                // this.show_test = false; // already done above
              }
              return;

              if (this.show_scorm === 1) {
                this.showPassedMsg();
              }
              return false;
            }
          }
          if (test_type == "lesson") {
            this.open_lesson.remaining_attempts =
              resp.data.data.total_attempts - resp.data.data.attempts;
          }

          if (test_type == 'scorm') {
            if (resp.data.status == 1) {
              if (this.all_tests.length > 0) {
                this.scormFlag = false;
                this.pretestFlag = false;
                this.show_test = true;
                // Reset to show description first when showing test after scorm
                this.showDescriptionStep = true;
                Swal.fire({
                  icon: resp.data.status ? "success" : "error",
                  html: resp.data.message,
                  confirmButtonClass: "btn btn-success",
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                });
              }
              this.getTest();
              return false;
            }
          }

          Swal.fire({
            icon: resp.data.status ? "success" : "error",
            html: resp.data.message,
            confirmButtonClass: "btn btn-success",
            confirmButtonText: "OK",
            // buttonsStyling: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.value) {

              if (resp.data.data.pass_fail == 1) {
                window.location.reload(true);
              }

              document.getElementById("lesson_test").reset();
              if (test_type == "lesson") {
                for (let question of this.open_lesson.questions) {
                  question.selected = "";
                  question.selected_answers = [];
                }
                this.refreshLessonQuesions();
              }
              if (test_type == "test") {
                for (let question of this.open_test.questions) {
                  question.selected = "";
                  question.selected_answers = [];
                }
                this.refreshTestQuesions();
              }
              // Reset current question index and show description first after submission
              this.currentQuestionIndex = 0;
              this.showDescriptionStep = true;
            }
          });
        })
        .catch(error => {
          if (error.response.status === 422) {
            Swal.fire({
              title: "Error!",
              html: error.response.data.message,
              icon: "error",
              confirmButtonClass: 'btn btn-success',
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Somthing went wrong!",
              icon: "error",
              confirmButtonClass: 'btn btn-success',
            });
          }
        });
    },
    refreshLessonQuesions() {
      axios.post(`${this.$baseUrl}/course/full_data`, {
        course_id: this.course_id,
        user_id: this.user_id,
      }, {
        headers: {
          Authorization: `Bearer ${this.hot_token}`,
          'Content-Type': 'application/json',
        }
      })
        .then((resp) => {
          this.open_lesson.questions = [];
          let lessons = resp.data[0].lessons;
          for (let lesson of lessons) {
            if (lesson.id == this.open_lesson.id) {
              let obj = {
                questions: [],
              };
              let questions = lesson.questions;

              for (let quest of questions) {
                let question_obj = {
                  id: quest.id,
                  pass: false,
                  question_text: quest.question,
                  attempts: quest.allowed_attempts,
                  allowed_attempts: quest.allowed_attempts,
                  status: false,
                  correct_answers: "",
                  selected_answers: [],
                  options: [],
                };
                if (quest.status) {
                  question_obj.status = true;
                } else {
                  question_obj.status = false;
                }
                let options = quest.answers;
                for (let opt of options) {
                  if (opt.course_quiz_correct_answer) {
                    question_obj.correct_answers = opt.id;
                  }
                  let opt_obj = {
                    id: opt.id,
                    selected_answers: false,
                    option_text: opt.course_quiz_question_option,
                  };
                  question_obj.options.push(opt_obj);
                }
                obj.questions.push(question_obj);
              }
              for (let test of obj.questions) {
                this.open_lesson.questions.push(test);
              }
            }
          }
        });
    },
    refreshTestQuesions() {
      axios.post(`${this.$baseUrl}/course/full_data`, {
        course_id: this.course_id,
        user_id: this.user_id,
      }, {
        headers: {
          'Authorization': `Bearer ${this.hot_token}` // Pass token here
        }
      })
        .then((resp) => {
          this.open_test.questions = [];
          this.all_tests = resp.data[0].tests;
          for (let test of this.all_tests) {
            if (test.id == this.open_test.id) {
              let obj = {
                questions: [],
              };
              let questions = test.questions;
              var srl = 1;
              for (let quest of questions) {
                let question_obj = {
                  sr_no: srl,
                  id: quest.id,
                  pass: false,
                  question_text: quest.question,
                  attempts: quest.allowed_attempts,
                  allowed_attempts: quest.allowed_attempts,
                  status: false,
                  correct_answers: "",
                  selected_answers: [],
                  options: [],
                };
                if (quest.status) {
                  question_obj.status = true;
                } else {
                  question_obj.status = false;
                }
                let options = quest.answers;
                for (let opt of options) {
                  if (opt.course_quiz_correct_answer) {
                    question_obj.correct_answers = opt.id;
                  }
                  let opt_obj = {
                    id: opt.id,
                    selected_answers: false,
                    option_text: opt.course_quiz_question_option,
                  };
                  question_obj.options.push(opt_obj);
                }
                obj.questions.push(question_obj);
                srl++;
              }
              for (let test of obj.questions) {
                this.open_test.questions.push(test);
              }
            }
          }
        });
    },
    saveCourseCompletion: function (data) {
      this.isScormCompleted = true;
      this.submitAnswers(data, 'scorm');
    },
    maskSSN(index) {
      var x = this.pretest.questions[index].selected_answers.replace(/\D/g, "").match(/(\d{0,3})(\d{0,2})(\d{0,4})/);
      this.pretest.questions[index].selected_answers = !x[2] ? x[1] : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
    },
    dateFormat(index) {
      var x = this.pretest.questions[index].selected_answers.replace(/\D/g, "").match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
      this.pretest.questions[index].selected_answers = !x[2] ? x[1] : x[1] + "/" + x[2] + (x[3] ? "/" + x[3] : "");
      var userDateFormat = this.pretest.questions[index].selected_answers;
      this.dateFormatError = '';
      const parts = userDateFormat.split('/');
      if (parts[0] > 12 || parts[0] < 1) {
        this.dateFormatError = "Month must be between 1-12"
      }
      else if (parts[1] > 31 || parts[1] < 1) {
        this.dateFormatError = "Day must be between 1-31"
      }
      else if (parts[3] && parts[3].length < 4) {
        this.dateFormatError = "Invalid Year! Enter full year"
      }
    },
  },
}
</script>

<style scoped>
.mobile-lesson {
  min-height: 100vh;
}

.mobile-lesson {
  background: linear-gradient(to bottom,
      rgba(255, 245, 238, 1) 0%,
      rgba(255, 255, 255, 1) 44%,
      rgba(254, 230, 214, 1) 100%) fixed;
}

.progress-area {
  margin-top: 15px;
}

.progress-area .txt-size {
  font-size: 13px;
  padding-right: 7px;
}

.progress-area>>>.el-progress-bar__outer {
  background-color: rgba(255, 255, 255, 0.15);
}

.progress-area>>>.el-progress-bar__inner {
  background: linear-gradient(135deg, #e4973a 0%, #eb1a26 100%);
}

.center-res-md-right {
  text-align: right;
}

.no-border-card .card-footer {
  border-top: 0;
}

.remain-attempts {
  text-align: right;
}

.remain-attempts p {
  color: red;
  margin-bottom: 0;
}

.disabled:hover {
  cursor: not-allowed;
}

.scroll-timeline {
  overflow-y: auto !important;
  min-height: 200px;
  max-height: 200px;
}

#lesson_test p {
  font-size: 14px;
}

#lesson_test input[type="radio"] {
  margin-bottom: 10px;
}

#lesson_test b {
  font-size: 15px;
  font-weight: 600;
}

.remain-attempts p {
  text-align: center;
}

.lessonulLi .fa-check-circle {
  position: relative;
  top: 4px;
}

.custmHeightCard>>>.card-body {
  margin-bottom: 100px !important;
  overflow: auto !important;
  max-height: calc(100vh - 96px) !important;
  padding: 0
}

.card-qheader {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(61, 61, 61, 1) 100%);
  padding: 24px;
  border-radius: 0 0 30px 30px;
}

.cart-question-area {
  padding: 0 24px;
}
.el-tabs__item:hover {
  color:#eb1a26;
}

.custmHeightCard>>>.card-body {
  margin-bottom: 100px !important;
  overflow: auto !important;
  max-height: calc(100vh - 96px) !important;
  padding: 0;
}

.card-qheader {
  background: linear-gradient(to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(61, 61, 61, 1) 100%);
  padding: 24px;
  border-radius: 0 0 30px 30px;
}

.cart-question-area {
  padding: 0 24px;
}

.lessonulLi i {
  margin-right: 5px;
}

.left-margin {
  margin-left: 0px;
}

.wrong {
  background-color: #f32c2c;
  color: white;
  padding: 0px 6px 0px 6px;
  margin: 1px 0px 3px 10px;
  border: 1px solid #af1834;
  transition: background-color 1s linear;
  -webkit-transition: background-color 1s linear;
}

.correct {
  color: white;
  background-color: #28be28;
  padding: 0px 6px 0px 6px;
  margin: 1px 0px 3px 10px;
  border: 1px solid #538839;
  transition: background-color 1s linear;
  -webkit-transition: background-color 1s linear;
  animation: blinkingBackground 1s infinite;
  -webkit-animation: blinkingBackground 1s infinite;
  /* Safari 4+ */
  -moz-animation: blinkingBackground 1s infinite;
  /* Fx 5+ */
  -o-animation: blinkingBackground 1s infinite;
  /* Opera 12+ */
}

@keyframes blinkingBackground {
  0% {
    background-color: #2eaf2e;
  }

  25% {
    background-color: #14c614;
  }

  50% {
    background-color: #2eaf2e;
  }

  75% {
    background-color: #14c614;
  }

  100% {
    background-color: #2eaf2e;
  }
}

.styleResult {
  padding: 20px;
  color: black;
  font-weight: bold;
}

.exam-button-wrapper {
  position: absolute;
  right: 20px;
  bottom: 23px;
}

.exam-button-wrapper a[disabled="disabled"] {
  pointer-events: none;
}

.exam-button-wrapper.has-errors a {
  background-color: #ff0000;
  border-color: #60aeff;
}

.exam-button-wrapper.has-errors a .fas {
  display: none;
}

.exam-button-wrapper span.service-unavailable {
  display: block;
  padding: 5px;
  text-align: center;
  font-weight: 600;
}

label.qtn-checkbox {
  padding: 13px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 10px 0;
  width: 100%;
  border: 1px solid #ebebeb;
  border-radius: 50px;
}

label.qtn-checkbox input[type="radio"] {
  margin-bottom: 0 !important;
}

label.qtn-checkbox.lable-style {
  border: 1px solid #eb1a26;
}

/* @media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) {*/
  iframe {
    width: 100% !important;
    height: auto !important;
  }
  @media only screen and (min-width: 575px) {
      iframe {
      height: 300px !important;
  }
}
/* }  */

label.qtn-checkbox input[type="radio"] {
  margin-bottom: 0 !important;
}

label.qtn-checkbox.lable-style {
  border: 1px solid #eb1a26;
}

 /* @media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) { */
  /* iframe {
    width: 100% !important;
    height: auto !important;
  } */
/* }  */

.counter {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.2);
  padding: 5px 18px 5px 15px;
  border-radius: 22px;
  font-size: 9px;
  display: flex;
  align-items: center;
}

.timer-img {
  margin-right: 5px;
  margin-top: -2px;
}

.slider {
  height: 400px !important;
  border: 1px solid #ebeef5;
  overflow-y: auto !important;
}

.slider-indicators {
  visibility: hidden !important;
}

.slider-btn-left {
  background: none !important;
}

.slider-btn-right {
  right: 6px !important;
  background: none !important;
}

.slider-btn {
  position: absolute;
  top: 50% !important;
  z-index: 999;
  height: 20px !important;
  width: 20px !important;
  border: none;
  background: #fff;
  color: #0b427b;
  outline: 0;
  transition: none !important;
  cursor: pointer;
}

.slider-icon {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-left: 2px solid rgb(10 206 255) !important;
  border-bottom: 2px solid rgb(10 206 255) !important;
  transition: border 0.2s;
}

.slider-indicator-icon {
  background-color: #0b427b !important;
}

.slider-indicator-active {
  background-color: rgb(10 206 255) !important;
}

.slider::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
  border-radius: 10px;
}

.slider::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

.slider::-webkit-scrollbar-thumb {
  background-color: #c0c4cc;
  border-radius: 10px;
}

.ql-align-center {
  text-align: center !important;
}

.ql-align-right {
  text-align: right !important;
}

/* .course-disc p img{
max-width: 100% !important;
height: 310px !important;
} */

.scorm-player iframe {
  height: 80vh !important;
  /*width: calc(100vw - 340px);*/
  width: 100%;
}

/* @media (max-width: 768px) {*/
  .scorm-player iframe {
    height: 67vh !important;
  }

  .content {
    padding-bottom: 0px;
  }

  .scroll-timeline {
    min-height: auto !important;
  }

  #adobe-dc-view iframe {
    height: 70vh !important;
  }

  .attemp-course .test-courst-name {
    margin-bottom: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .test-q-name {
    font-size: 11px;
  }

  .hours,
  .minutes,
  .seconds,
  #colon {
    font-size: 16px;
  }

  .center-res-md-right {
    text-align: center;
  }
/* }  */
/*
@media (max-width: 786px) {*/
  .scorm-player iframe {
    height: calc(88vh - 134px) !important;
  }

  .custmHeightCard {
  }
/* }  */

.btn-sticky-area {
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 24px;
  width: 100%;
}

.card {
  background: transparent;
  margin: 0;
  box-shadow: none;
  border: 0;
}

.lesson-btn {
  background: linear-gradient(135deg, #e4973a 0%, #eb1a26 100%);
  color: #fff;
  padding-top: 13px;
  padding-bottom: 13px;
}

.cart-question-area>>>.el-tabs__item.is-active {
  color: #eb1a26;
}

.cart-question-area>>>.el-tabs__nav-wrap {
  margin-bottom: 20px;
}

.cart-question-area>>>.el-tabs__active-bar {
  background-color: #eb1a26;
}

.cart-question-area>>>.el-tabs__nav {
  width: 100%;
}

.cart-question-area>>>#tab-first {
  width: 50%;
  font-size: 16px;
  text-align: center;
}

.cart-question-area>>>#tab-second {
  width: 50%;
  font-size: 16px;
  text-align: center;
}
.congratulations-container {
padding: 24px;
min-height: 100vh;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
display: none;
}
.card-header-hd {
  width: calc(100% - 55px);
}
.hide-body {
  display: none;
}
.show-congratulations.congratulations-container {
  display: flex;
}
.passing-gread {
  text-align: left;
}

</style>

